class FirehawkCRMAddressPicker {
	field = null
	manualAddressLink = null
	loadingElement = null
	addressCard = null
	addressForm = null

	currentQuery = null;
	selectedAddress = null
	googleListener = null

	addressChanged = null
	addressInvalid = true
	defaultCountry = "Australia"
	defaultValue = null
	hideCountryPicker = false

	addressAutoComplete = null

	calculateDistanceFromLocations = null;
	distanceCalculations = {};
	distanceRequest = null

	restrictResultsByState = null;
	restrictResultsByCity = null;
	didRestrictAddress = false;

	disableManualEdits = false;

	isShowingLoading = false

	constructor(container, defaultCountry, hideCountry, defaultValue, calculateDistanceFromLocations, disableManualEdits, restrictResultsByState, restrictResultsByCity) {
		this.container = jQuery(container);
		this.defaultCountry = defaultCountry || "Australia";
		this.hideCountryPicker = hideCountry;
		this.defaultValue = defaultValue;
		this.calculateDistanceFromLocations = calculateDistanceFromLocations;
		this.restrictResultsByState = restrictResultsByState;
		this.restrictResultsByCity = restrictResultsByCity
		this.disableManualEdits = disableManualEdits;

		if (this.defaultValue && Array.isArray(defaultValue)) {
			this.selectedAddress = this.defaultValue[0]
			this.addressInvalid = false
		} else if (this.defaultValue && typeof defaultValue == "object") {
			this.selectedAddress = this.defaultValue
			this.addressInvalid = false
		}

		this.field = jQuery(`<input type="text" class="form-control" placeholder="Type an address here" autocomplete="off">`)
		this.manualAddressLink = jQuery(`<a href class="manual-address-link">can’t find the address?</a>`)
		this.container.append(this.field)

		if (this.disableManualEdits != true) {
			this.container.append(this.manualAddressLink);
		}

		this.loadingElement = jQuery(`<div class="grid-loading scale-in-center"><div class="firehawk-crm-search-spinner primary lg"></div></div>`)

		this.configureGoogleSearch()
		this.observer()

		if (this.selectedAddress) {
			this.updateGoogleAutoComplete()
			this.showAddressInfo()
		}
	}

	hideLoading() {
		this.loadingElement.remove()
	}

	showLoading() {
		this.container.before(this.loadingElement)
	}

	observer() {
		var me = this

		jQuery(this.container).delegate(".address-picker-info-card .remove-btn", "click", (event) => {
			this.didRestrictAddress = false;
			this.removeAddressInfo()
		})

		if (this.disableManualEdits != true) {
			jQuery(this.container).delegate(".address-picker-info-card .edit-btn", "click", (event) => {
				this.showAddressForm()
			})
		}

		jQuery(this.container).delegate(".manual-address-link", "click", (event) => {
			event.preventDefault()
			this.showAddressForm()
		})

		jQuery(this.container).delegate(".address-picker-info-form .save-address-btn", "click", (event) => {
			this.onAddressFormSave()
		})

		jQuery(this.container).delegate(".address-picker-info-form .cancel-btn", "click", (event) => {
			this.onAddressFormCancel()
		})

		jQuery(this.container).delegate(".address-picker-info-form #country", "change", (event) => {
			if (this.addressForm) {
				var field = jQuery(event.currentTarget)
				var value = field.val()
				var isPicker = this.addressForm.find("#state").hasClass("form-select")

				var options = this.states(value)
				if (isPicker || options && !isPicker) {
					this.refreshAddressForm()
				}
			}
		})
	}

	addressInfoCard() {
		let addressCard = jQuery(`<div class="address-picker-info-card card"></div>`)
		let addressCardBody = jQuery(`<div class="card-body"></div>`)

		if (this.selectedAddress) {
			var addressParts = []
			var line1 = []
			var line2 = []

			if (this.selectedAddress.unit) line1.push(this.selectedAddress.unit)
			if (this.selectedAddress.line1) line1.push(this.selectedAddress.line1)
			if (this.selectedAddress.city) line2.push(this.selectedAddress.city)
			if (this.selectedAddress.state) line2.push(this.selectedAddress.state)
			if (this.selectedAddress.postcode) line2.push(this.selectedAddress.postcode)

			if (this.selectedAddress.name) addressParts.push(this.selectedAddress.name)
			if (line1.length) addressParts.push(line1.join("/"))
			if (line2.length) addressParts.push(line2.join(" "))
			if (this.selectedAddress.country) addressParts.push(this.selectedAddress.country)

			if (addressParts.length) {
				addressCardBody.append(`<div class="address-line card-text">${addressParts.join(", ")}</div>`)
			}
		}

		let actions = jQuery(`<div class="address-picker-info-actions"></div>`)
		actions.append(`<button class="btn btn-link-danger remove-btn me-3 action-btn" type="button"><span class="sr-only">Remove</span><i class="far fa-regular fa-trash"></i></button>`)
		
		if (this.disableManualEdits != true) {
			actions.append(`<button class="btn btn-link-dark edit-btn action-btn" type="button"><span class="sr-only">Edit</span><i class="far fa-regular fa-pencil"></i></button>`)
		}
		actions.append(`<span class="field-spinner fcrms-spinner primary large d-none" role="status" aria-hidden="true"></span>`)

		addressCardBody.append(actions)
		addressCard.append(addressCardBody)
		return addressCard
	}

	addressInfoForm(address) {
		let form = jQuery(`<div class="address-picker-info-form card"></div>`)
		let formBody = jQuery(`<div class="card-body">
			<h5 class="card-title">${this.selectedAddress ? 'Edit Address' : 'Add Address'}</h5>
		</div>`)

		let selectedCountry = address.country || this.defaultCountry

		let countyStateCountries = ["United Kingdom"]

		let postcodeLabel = selectedCountry == "United States" ? "Zipcode" : "Postcode"
		let stateLabel = selectedCountry && countyStateCountries.includes(selectedCountry) ? "County" : "State"

		let selectedState = address.state
		if (selectedCountry == "Australia") {
			selectedState = address.state_long || address.state;
		}

		let fields = [
			{ id: "line1", label: "Line 1", value: address.line1, placeholder: "Street number / Street name" },
			{ id: "unit", label: "Unit", value: address.unit, placeholder: "Apartment, Unit, etc."},
			{ id: "name", label: "Building Name", value: address.name },
			{ id: "city", label: "City", value: address.city, classes: "col-12 col-md" },
			{ id: "state", label: stateLabel, value: selectedState, classes: "col-12 col-md" },
			{ id: "postcode", label: postcodeLabel, value: address.postcode, classes: "col-12 col-md", required: true }
		]

		if (this.hideCountryPicker != true) {
			fields.push({ id: "country", value: selectedCountry, label: "Country" })
		}

		let formRow = jQuery(`<div class="row"></div>`)
		for (let field of fields) {
			let formField = this.addressInfoField(field, selectedCountry)
			formRow.append(formField)
		}

		formBody.append(formRow)

		let formActions = jQuery(`<div class="form-actions mt-2"></div>`)
		formActions.append(`<button class="btn btn-light cancel-btn me-3" type="button">Cancel</button>`)
		formActions.append(`<button class="btn btn-primary save-address-btn" type="button">Save</button>`)

		formBody.append(formActions)
		form.append(formBody)

		return form
	}

	addressInfoField(field, country) {
		let fieldGroup = jQuery(`<div class="form-group ${field.classes || ""}"></div>`)
		if(field.required) {
			fieldGroup.append(`<label class="form-label" for="${field.id}">${field.label}<span class="required">*</span></label>`)
		} else {
			fieldGroup.append(`<label class="form-label" for="${field.id}">${field.label}</label>`)
		}

		let requiredAttribute = ""
		if(field.required) {
			requiredAttribute = "data-required='true'"
		}
		if (field.id == "country") {
			let options = this.countries().map((country) => {
				var selected = ""
				if (field.value == country.name) {
					selected = `selected="selected"`
				}

				return `<option value="${country.name}" id="${country.name}" ${selected}>${country.name}</option>`
			})
			fieldGroup.append(`<select class="form-select" id="${field.id}" name="${field.id}">${options}</select>`)
		} else if (field.id == "state" && this.states(country)) {
			let options = this.states(country).map((state) => {
				var selected = ""
				if (field.value == state.name) {
					selected = `selected="selected"`
				}
				return `<option value="${state.name}" id="${state.name}" ${selected}>${state.name}</option>`
			})

			fieldGroup.append(`<select class="form-select" id="${field.id}" name="${field.id}">${options}</select>`)
		} else {
			let formField = jQuery(`<input class="form-control" id="${field.id}" placeholder="${field.placeholder || ""}"  name="${field.id}" ${requiredAttribute}/>`)
			if (field.value != null) {
				formField.val(field.value)
			}
			fieldGroup.append(formField)
		}

		return fieldGroup
	}

	showAddressInfo() {
		if (this.addressCard) {
			this.addressCard.remove()
		}

		this.addressCard = this.addressInfoCard()
		this.container.append(this.addressCard)

		this.field.hide()
		this.manualAddressLink.hide()

		if (this.isShowingLoading) {
			this.toggleAddressLoader(true)
		}
	}

	refreshAddressForm() {
		var currentData = {}
		if (this.addressForm) {
			jQuery.each(this.addressForm.find("input, select"), function() {
				var field = jQuery(this)
				var id = field.attr("id")
				var value = field.val()
				if (id) {
					currentData[field.attr("id")] = value
				}
			})

			this.addressForm.remove()
		}

		this.addressForm = this.addressInfoForm(currentData)
		this.container.append(this.addressForm)
	}

	showAddressForm() {
		if (this.addressCard) {
			this.addressCard.hide()
		}

		if (this.addressForm) this.addressForm.remove()

		this.addressForm = this.addressInfoForm(this.selectedAddress || {})
		this.container.append(this.addressForm)

		this.field.hide()
		this.manualAddressLink.hide()
	}

	onAddressFormCancel() {
		if (this.addressForm) this.addressForm.remove()

		if (this.selectedAddress) {
			if (this.addressCard) this.addressCard.show()
		} else {
			this.field.show()
			this.manualAddressLink.show()
		}
	}

	onAddressFormSave() {
		if (this.addressForm) {
			let invalid = false;
			var address = {}
			jQuery.each(this.addressForm.find("input, select"), function() {
				var field = jQuery(this)
				var id = field.attr("id")
				var value = field.val()
				if (id == "postcode" && (!value || !(value.trim()).length)) {
					invalid = true;
					return;
				}
				if (id) {
					address[field.attr("id")] = value
				}
			})

			var hasSomeFields = Object.keys(address).filter(key => {
				if (!address[key] || !address[key].length) return false
				return true
			}).length

			if (invalid) {
				this.addressInvalid = true

				if (this.addressForm) this.addressForm.remove()

				if (hasSomeFields) {
					address.full = this.formatFullAddress(address)
					this.selectedAddress = address
					this.showAddressInfo()
				} else {
					this.selectedAddress = null
					this.field.show()
					this.manualAddressLink.show()
				}

				if (this.addressChanged) this.addressChanged(this.selectedAddress)
				return;
			}

			this.addressInvalid = false
			address.full = this.formatFullAddress(address)
			this.selectedAddress = address
			this.updateGoogleAutoComplete()
			if (this.addressChanged) this.addressChanged(this.selectedAddress)
		}

		if (this.addressForm) this.addressForm.remove()

		if (this.selectedAddress) {
			this.showAddressInfo()
		} else {
			this.field.show()
			this.manualAddressLink.show()
		}
	}

	updateGoogleAutoComplete() {
		if (!this.addressAutoComplete) return;

		var countries = this.countries()
		var country = this.selectedAddress && this.selectedAddress.country || this.defaultCountry

		if (country && countries.filter(c => c.name == country).length > 0) {
			var country = countries.filter(c => c.name == country)[0]
			this.addressAutoComplete.setComponentRestrictions({
				country: [country.code]
			})
		} else {
			this.addressAutoComplete.setComponentRestrictions({
				country: []
			})
		}

		// if (this.calculateDistanceFromLocations && this.calculateDistanceFromLocations.length) {
		// 	this.runDistanceCalculationChecks()
		// }
	}

	runDistanceCalculationChecks(callback) {
		if (this.distanceRequest) {
			this.distanceRequest.abort()
		}

		if (!this.selectedAddress) {
			this.distanceCalculations = {}
			this.toggleAddressLoader(false)
			if (callback) callback()
			return
		}

		this.toggleAddressLoader(true)
		var params = {
			origins: this.calculateDistanceFromLocations,
			address: this.selectedAddress.full,
			units: "kilometre"
		}

		this.distanceRequest = jQuery.ajax({
			method: 'post',
			url: ajax_var.url,
			data: {
				action: 'calculate_address_distances',
				params: params
			}
		}).done((response) => {
			let results = response && response.results || []
			this.distanceCalculations = {}

			for (let result of results) {
				this.distanceCalculations[result.id] = result.distance
			}

			this.toggleAddressLoader(false)
			if (callback) callback()
		}).fail(function (xhr, status, error) {
			console.error(error)
			this.distanceCalculations = {}
			if (callback) callback()
		})
	}

	toggleAddressLoader(show) {
		this.isShowingLoading = show
		if (show) {
			jQuery(this.container).find(".address-picker-info-actions .action-btn").addClass("d-none")
			jQuery(this.container).find(".address-picker-info-actions .field-spinner").removeClass("d-none")
			jQuery(this.container).find(".address-picker-info-card").addClass("verifying")
		} else {
			jQuery(this.container).find(".address-picker-info-actions .action-btn").removeClass("d-none")
			jQuery(this.container).find(".address-picker-info-actions .field-spinner").addClass("d-none")
			jQuery(this.container).find(".address-picker-info-card").removeClass("verifying")
		}
	}

	removeAddressInfo() {
		if (this.addressCard) {
			this.addressCard.remove()
		}

		this.field.show()
		this.field.val(null)
		this.addressInvalid = true
		this.didRestrictAddress = false;
		this.manualAddressLink.show()
		this.selectedAddress = null
		this.updateGoogleAutoComplete()
		if (this.addressChanged) this.addressChanged(this.selectedAddress)
	}

	configureGoogleSearch() {
		var element = jQuery(this.field)

		if (typeof google === "undefined" || typeof google.maps == "undefined" || typeof google.maps.places == "undefined") {
			return
		}

		this.addressAutoComplete = new google.maps.places.Autocomplete(element[0]);

		var defaultCountry = this.countries().filter(c => c.name == this.defaultCountry)[0]
		if (defaultCountry && defaultCountry.code) {
			this.addressAutoComplete.setComponentRestrictions({
				country: [defaultCountry.code]
			})
		}

		this.googleListener = this.addressAutoComplete.addListener('place_changed', () => {
			var place = this.addressAutoComplete.getPlace()
			var addressComponents = place["address_components"] || {}
			var address = {
				full: place.formatted_address
			}
			var lineOneComponents = [];

			for (let element of addressComponents) {
				if (element && element.types && element.types.length && ((element.long_name && element.long_name.length) || (element.short_name && element.short_name.length))) {
					if (element.types.includes("subpremise")) {
						address.unit = element.long_name || element.short_name || null
					} else if (element.types.includes("street_number")) {
						address.streetNumber = element.long_name || element.short_name || null
						if (address.streetNumber && address.streetNumber.length) {
							lineOneComponents.push(`${address.streetNumber}`)
						}
					} else if (element.types.includes("route")) {
						address.street = element.long_name || element.short_name || null
						if (address.street && address.street.length) {
							lineOneComponents.push(`${address.street}`)
						}
					} else if (element.types.includes("sublocality")) {
						address.suburb = element.long_name || element.short_name || null
					} else if (element.types.includes("locality")) {
						if (this.isUKFuneralTeam) {
							address.line2 = element.long_name || element.short_name || null
						} else {
							address.city = element.long_name || element.short_name || null
						}
					} else if (element.types.includes("postal_town")) {
						address.city = element.long_name || element.short_name || null
					} else if (element.types.includes("neighborhood")) {
						address.line2 = element.long_name || element.short_name || null
					} else if (element.types.includes("administrative_area_level_2")) {
						address.county = element.short_name || element.long_name || null;
						address.state = element.short_name || element.long_name || null
						address.state_long = element.long_name || element.short_name || null
					} else if (element.types.includes("administrative_area_level_1")) {
						address.state = element.short_name || element.long_name || address.state || null
						address.state_long = element.long_name || element.short_name || address.state_long || null
					} else if (element.types.includes("postal_code")) {
						address.postcode = element.long_name || element.short_name || null
					} else if (element.types.includes("country")) {
						address.country = element.long_name || element.short_name || null
					} else if (element.types.includes("premise")) {
						address.name = element.long_name || element.short_name || null
					}
				}
			}

			if (lineOneComponents && lineOneComponents.length) {
				address.line1 = lineOneComponents.join(" ")
			}

			if (place && place.business_status && place.business_status.length && ((place.name && place.name.length) || (place.long_name && place.long_name.length))) {
				address.name = place.long_name || place.name || null
			}

			if (this.restrictResultsByCity != null && address.city != this.restrictResultsByCity) {
				this.didRestrictAddress = true;
			} else if (this.restrictResultsByState != null && address.state != this.restrictResultsByState) {
				this.didRestrictAddress = true;
			} else {
				this.didRestrictAddress = false;
			}
			
			this.addressInvalid = false
			address.full = this.formatFullAddress(address)
			this.selectedAddress = address
			this.updateGoogleAutoComplete()
			if (this.addressChanged) this.addressChanged(this.selectedAddress)
			this.showAddressInfo()
		})
	}

	findGoogleAddressPart(address_components, query, val = null) {
		for (let attr of address_components) {
			for (let type of attr.types) {
				if (Array.isArray(query) && query.filter(q => q == type).length > 0) {
					var value = val ? attr[val] : "";
					return value && value.length ? value : null
				} else if (type === query) {
					var value = val ? attr[val] : "";
					return value && value.length ? value : null
				}
			}
		}
		return null;
	}

	countries() {
		return [{"name":"Afghanistan","code":"AF"},{"name":"Åland Islands","code":"AX"},{"name":"Albania","code":"AL"},{"name":"Algeria","code":"DZ"},{"name":"American Samoa","code":"AS"},{"name":"AndorrA","code":"AD"},{"name":"Angola","code":"AO"},{"name":"Anguilla","code":"AI"},{"name":"Antarctica","code":"AQ"},{"name":"Antigua and Barbuda","code":"AG"},{"name":"Argentina","code":"AR"},{"name":"Armenia","code":"AM"},{"name":"Aruba","code":"AW"},{"name":"Australia","code":"AU"},{"name":"Austria","code":"AT"},{"name":"Azerbaijan","code":"AZ"},{"name":"Bahamas","code":"BS"},{"name":"Bahrain","code":"BH"},{"name":"Bangladesh","code":"BD"},{"name":"Barbados","code":"BB"},{"name":"Belarus","code":"BY"},{"name":"Belgium","code":"BE"},{"name":"Belize","code":"BZ"},{"name":"Benin","code":"BJ"},{"name":"Bermuda","code":"BM"},{"name":"Bhutan","code":"BT"},{"name":"Bolivia","code":"BO"},{"name":"Bosnia and Herzegovina","code":"BA"},{"name":"Botswana","code":"BW"},{"name":"Bouvet Island","code":"BV"},{"name":"Brazil","code":"BR"},{"name":"British Indian Ocean Territory","code":"IO"},{"name":"Brunei Darussalam","code":"BN"},{"name":"Bulgaria","code":"BG"},{"name":"Burkina Faso","code":"BF"},{"name":"Burundi","code":"BI"},{"name":"Cambodia","code":"KH"},{"name":"Cameroon","code":"CM"},{"name":"Canada","code":"CA"},{"name":"Cape Verde","code":"CV"},{"name":"Cayman Islands","code":"KY"},{"name":"Central African Republic","code":"CF"},{"name":"Chad","code":"TD"},{"name":"Chile","code":"CL"},{"name":"China","code":"CN"},{"name":"Christmas Island","code":"CX"},{"name":"Cocos (Keeling) Islands","code":"CC"},{"name":"Colombia","code":"CO"},{"name":"Comoros","code":"KM"},{"name":"Congo","code":"CG"},{"name":"Congo, The Democratic Republic of the","code":"CD"},{"name":"Cook Islands","code":"CK"},{"name":"Costa Rica","code":"CR"},{"name":"Cote D'Ivoire","code":"CI"},{"name":"Croatia","code":"HR"},{"name":"Cuba","code":"CU"},{"name":"Cyprus","code":"CY"},{"name":"Czech Republic","code":"CZ"},{"name":"Denmark","code":"DK"},{"name":"Djibouti","code":"DJ"},{"name":"Dominica","code":"DM"},{"name":"Dominican Republic","code":"DO"},{"name":"Ecuador","code":"EC"},{"name":"Egypt","code":"EG"},{"name":"El Salvador","code":"SV"},{"name":"Equatorial Guinea","code":"GQ"},{"name":"Eritrea","code":"ER"},{"name":"Estonia","code":"EE"},{"name":"Ethiopia","code":"ET"},{"name":"Falkland Islands (Malvinas)","code":"FK"},{"name":"Faroe Islands","code":"FO"},{"name":"Fiji","code":"FJ"},{"name":"Finland","code":"FI"},{"name":"France","code":"FR"},{"name":"French Guiana","code":"GF"},{"name":"French Polynesia","code":"PF"},{"name":"French Southern Territories","code":"TF"},{"name":"Gabon","code":"GA"},{"name":"Gambia","code":"GM"},{"name":"Georgia","code":"GE"},{"name":"Germany","code":"DE"},{"name":"Ghana","code":"GH"},{"name":"Gibraltar","code":"GI"},{"name":"Greece","code":"GR"},{"name":"Greenland","code":"GL"},{"name":"Grenada","code":"GD"},{"name":"Guadeloupe","code":"GP"},{"name":"Guam","code":"GU"},{"name":"Guatemala","code":"GT"},{"name":"Guernsey","code":"GG"},{"name":"Guinea","code":"GN"},{"name":"Guinea-Bissau","code":"GW"},{"name":"Guyana","code":"GY"},{"name":"Haiti","code":"HT"},{"name":"Heard Island and Mcdonald Islands","code":"HM"},{"name":"Holy See (Vatican City State)","code":"VA"},{"name":"Honduras","code":"HN"},{"name":"Hong Kong","code":"HK"},{"name":"Hungary","code":"HU"},{"name":"Iceland","code":"IS"},{"name":"India","code":"IN"},{"name":"Indonesia","code":"ID"},{"name":"Iran, Islamic Republic Of","code":"IR"},{"name":"Iraq","code":"IQ"},{"name":"Ireland","code":"IE"},{"name":"Isle of Man","code":"IM"},{"name":"Israel","code":"IL"},{"name":"Italy","code":"IT"},{"name":"Jamaica","code":"JM"},{"name":"Japan","code":"JP"},{"name":"Jersey","code":"JE"},{"name":"Jordan","code":"JO"},{"name":"Kazakhstan","code":"KZ"},{"name":"Kenya","code":"KE"},{"name":"Kiribati","code":"KI"},{"name":"Korea, Democratic People'S Republic of","code":"KP"},{"name":"Korea, Republic of","code":"KR"},{"name":"Kuwait","code":"KW"},{"name":"Kyrgyzstan","code":"KG"},{"name":"Lao People'S Democratic Republic","code":"LA"},{"name":"Latvia","code":"LV"},{"name":"Lebanon","code":"LB"},{"name":"Lesotho","code":"LS"},{"name":"Liberia","code":"LR"},{"name":"Libyan Arab Jamahiriya","code":"LY"},{"name":"Liechtenstein","code":"LI"},{"name":"Lithuania","code":"LT"},{"name":"Luxembourg","code":"LU"},{"name":"Macao","code":"MO"},{"name":"Macedonia, The Former Yugoslav Republic of","code":"MK"},{"name":"Madagascar","code":"MG"},{"name":"Malawi","code":"MW"},{"name":"Malaysia","code":"MY"},{"name":"Maldives","code":"MV"},{"name":"Mali","code":"ML"},{"name":"Malta","code":"MT"},{"name":"Marshall Islands","code":"MH"},{"name":"Martinique","code":"MQ"},{"name":"Mauritania","code":"MR"},{"name":"Mauritius","code":"MU"},{"name":"Mayotte","code":"YT"},{"name":"Mexico","code":"MX"},{"name":"Micronesia, Federated States of","code":"FM"},{"name":"Moldova, Republic of","code":"MD"},{"name":"Monaco","code":"MC"},{"name":"Mongolia","code":"MN"},{"name":"Montserrat","code":"MS"},{"name":"Morocco","code":"MA"},{"name":"Mozambique","code":"MZ"},{"name":"Myanmar","code":"MM"},{"name":"Namibia","code":"NA"},{"name":"Nauru","code":"NR"},{"name":"Nepal","code":"NP"},{"name":"Netherlands","code":"NL"},{"name":"Netherlands Antilles","code":"AN"},{"name":"New Caledonia","code":"NC"},{"name":"New Zealand","code":"NZ"},{"name":"Nicaragua","code":"NI"},{"name":"Niger","code":"NE"},{"name":"Nigeria","code":"NG"},{"name":"Niue","code":"NU"},{"name":"Norfolk Island","code":"NF"},{"name":"Northern Mariana Islands","code":"MP"},{"name":"Norway","code":"NO"},{"name":"Oman","code":"OM"},{"name":"Pakistan","code":"PK"},{"name":"Palau","code":"PW"},{"name":"Palestinian Territory, Occupied","code":"PS"},{"name":"Panama","code":"PA"},{"name":"Papua New Guinea","code":"PG"},{"name":"Paraguay","code":"PY"},{"name":"Peru","code":"PE"},{"name":"Philippines","code":"PH"},{"name":"Pitcairn","code":"PN"},{"name":"Poland","code":"PL"},{"name":"Portugal","code":"PT"},{"name":"Puerto Rico","code":"PR"},{"name":"Qatar","code":"QA"},{"name":"Reunion","code":"RE"},{"name":"Romania","code":"RO"},{"name":"Russian Federation","code":"RU"},{"name":"RWANDA","code":"RW"},{"name":"Saint Helena","code":"SH"},{"name":"Saint Kitts and Nevis","code":"KN"},{"name":"Saint Lucia","code":"LC"},{"name":"Saint Pierre and Miquelon","code":"PM"},{"name":"Saint Vincent and the Grenadines","code":"VC"},{"name":"Samoa","code":"WS"},{"name":"San Marino","code":"SM"},{"name":"Sao Tome and Principe","code":"ST"},{"name":"Saudi Arabia","code":"SA"},{"name":"Senegal","code":"SN"},{"name":"Serbia and Montenegro","code":"CS"},{"name":"Seychelles","code":"SC"},{"name":"Sierra Leone","code":"SL"},{"name":"Singapore","code":"SG"},{"name":"Slovakia","code":"SK"},{"name":"Slovenia","code":"SI"},{"name":"Solomon Islands","code":"SB"},{"name":"Somalia","code":"SO"},{"name":"South Africa","code":"ZA"},{"name":"South Georgia and the South Sandwich Islands","code":"GS"},{"name":"Spain","code":"ES"},{"name":"Sri Lanka","code":"LK"},{"name":"Sudan","code":"SD"},{"name":"Suriname","code":"SR"},{"name":"Svalbard and Jan Mayen","code":"SJ"},{"name":"Swaziland","code":"SZ"},{"name":"Sweden","code":"SE"},{"name":"Switzerland","code":"CH"},{"name":"Syrian Arab Republic","code":"SY"},{"name":"Taiwan, Province of China","code":"TW"},{"name":"Tajikistan","code":"TJ"},{"name":"Tanzania, United Republic of","code":"TZ"},{"name":"Thailand","code":"TH"},{"name":"Timor-Leste","code":"TL"},{"name":"Togo","code":"TG"},{"name":"Tokelau","code":"TK"},{"name":"Tonga","code":"TO"},{"name":"Trinidad and Tobago","code":"TT"},{"name":"Tunisia","code":"TN"},{"name":"Turkey","code":"TR"},{"name":"Turkmenistan","code":"TM"},{"name":"Turks and Caicos Islands","code":"TC"},{"name":"Tuvalu","code":"TV"},{"name":"Uganda","code":"UG"},{"name":"Ukraine","code":"UA"},{"name":"United Arab Emirates","code":"AE"},{"name":"United Kingdom","code":"GB"},{"name":"United States","code":"US"},{"name":"United States Minor Outlying Islands","code":"UM"},{"name":"Uruguay","code":"UY"},{"name":"Uzbekistan","code":"UZ"},{"name":"Vanuatu","code":"VU"},{"name":"Venezuela","code":"VE"},{"name":"Viet Nam","code":"VN"},{"name":"Virgin Islands, British","code":"VG"},{"name":"Virgin Islands, U.S.","code":"VI"},{"name":"Wallis and Futuna","code":"WF"},{"name":"Western Sahara","code":"EH"},{"name":"Yemen","code":"YE"},{"name":"Zambia","code":"ZM"},{"name":"Zimbabwe","code":"ZW"}, ,{"name":"Unknown"}]
	}

	states(country) {
		if (country == "Australia") {
			return [{ "name": "Australian Capital Territory", "abbreviation": "ACT" }, { "name": "New South Wales", "abbreviation": "NSW" }, { "name": "Queensland", "abbreviation": "QLD" }, { "name": "Victoria", "abbreviation": "VIC" }, { "name": "South Australia", "abbreviation": "SA" }, { "name": "Western Australia", "abbreviation": "WA" }, { "name": "Tasmania", "abbreviation": "TAS" }, { "name": "Northern Territory", "abbreviation": "NT" }]
		}

		if (country == "United States") {
			return [{ "name": "Alabama", "abbreviation": "AL" }, { "name": "Alaska", "abbreviation": "AK" }, { "name": "American Samoa", "abbreviation": "AS" }, { "name": "Arizona", "abbreviation": "AZ" }, { "name": "Arkansas", "abbreviation": "AR" }, { "name": "California", "abbreviation": "CA" }, { "name": "Colorado", "abbreviation": "CO" }, { "name": "Connecticut", "abbreviation": "CT" }, { "name": "Delaware", "abbreviation": "DE" }, { "name": "District Of Columbia", "abbreviation": "DC" }, { "name": "Federated States Of Micronesia", "abbreviation": "FM" }, { "name": "Florida", "abbreviation": "FL" }, { "name": "Georgia", "abbreviation": "GA" }, { "name": "Guam", "abbreviation": "GU" }, { "name": "Hawaii", "abbreviation": "HI" }, { "name": "Idaho", "abbreviation": "ID" }, { "name": "Illinois", "abbreviation": "IL" }, { "name": "Indiana", "abbreviation": "IN" }, { "name": "Iowa", "abbreviation": "IA" }, { "name": "Kansas", "abbreviation": "KS" }, { "name": "Kentucky", "abbreviation": "KY" }, { "name": "Louisiana", "abbreviation": "LA" }, { "name": "Maine", "abbreviation": "ME" }, { "name": "Marshall Islands", "abbreviation": "MH" }, { "name": "Maryland", "abbreviation": "MD" }, { "name": "Massachusetts", "abbreviation": "MA" }, { "name": "Michigan", "abbreviation": "MI" }, { "name": "Minnesota", "abbreviation": "MN" }, { "name": "Mississippi", "abbreviation": "MS" }, { "name": "Missouri", "abbreviation": "MO" }, { "name": "Montana", "abbreviation": "MT" }, { "name": "Nebraska", "abbreviation": "NE" }, { "name": "Nevada", "abbreviation": "NV" }, { "name": "New Hampshire", "abbreviation": "NH" }, { "name": "New Jersey", "abbreviation": "NJ" }, { "name": "New Mexico", "abbreviation": "NM" }, { "name": "New York", "abbreviation": "NY" }, { "name": "North Carolina", "abbreviation": "NC" }, { "name": "North Dakota", "abbreviation": "ND" }, { "name": "Northern Mariana Islands", "abbreviation": "MP" }, { "name": "Ohio", "abbreviation": "OH" }, { "name": "Oklahoma", "abbreviation": "OK" }, { "name": "Oregon", "abbreviation": "OR" }, { "name": "Palau", "abbreviation": "PW" }, { "name": "Pennsylvania", "abbreviation": "PA" }, { "name": "Puerto Rico", "abbreviation": "PR" }, { "name": "Rhode Island", "abbreviation": "RI" }, { "name": "South Carolina", "abbreviation": "SC" }, { "name": "South Dakota", "abbreviation": "SD" }, { "name": "Tennessee", "abbreviation": "TN" }, { "name": "Texas", "abbreviation": "TX" }, { "name": "Utah", "abbreviation": "UT" }, { "name": "Vermont", "abbreviation": "VT" }, { "name": "Virgin Islands", "abbreviation": "VI" }, { "name": "Virginia", "abbreviation": "VA" }, { "name": "Washington", "abbreviation": "WA" }, { "name": "West Virginia", "abbreviation": "WV" }, { "name": "Wisconsin", "abbreviation": "WI" }, { "name": "Wyoming", "abbreviation": "WY" }]
		}

		return null
	}

	formatFullAddress(address) {
		var addressValue = address
		var addressArray = [];

		var countryIgnoreState = ["New Zealand", "United Kingdom"]

		if (addressValue) {
			
			if (address.country == "United Kingdom") {
				if (addressValue.businessName) {
					var name = `${addressValue.businessName}`.trim()
					var nameFull = name + ','
					addressArray.push(nameFull);
				}

				if (addressValue.name) {
					var name = `${addressValue.name}`.trim()
					var nameFull = name + ','
					addressArray.push(nameFull);
				}
			} else {
				if (addressValue.name) {
					var name = `${addressValue.name}`.trim()
					var nameFull = name + ','
					addressArray.push(nameFull);
				}
			}

			if (addressValue.unit) {
				var unit = `${addressValue.unit}`.trim()
				var unitFull = unit + '/'
				addressArray.push(unitFull);
			}

			if (addressValue.line1) {
				var line1 = `${addressValue.line1}`.trim()
				var line1Full = line1 + ','
				addressArray.push(line1Full);
			}

			if (addressValue.line2 && addressValue.country != 'United States') {
				let line2 = `${addressValue.line2}`.trim()
				let line2Full = line2 + ','
				addressArray.push(line2Full);
			}

			if (addressValue.suburb && addressValue.country == 'New Zealand') {
				var suburb = `${addressValue.suburb}`.trim()
				var suburbFull = suburb + ','
				addressArray.push(suburbFull);
			}

			if (addressValue.city) {
				var city = `${addressValue.city}`.trim()
				var cityFull = city + ','
				addressArray.push(cityFull);
			}

			if (addressValue.county) {
				var county = `${addressValue.county}`.trim()
				var countyFull = county + ','
				addressArray.push(countyFull);
			}

			if (addressValue.state && !countryIgnoreState.includes(addressValue.country)) {
				var state = `${addressValue.state}`.trim()
				var stateFull = state + ''
				addressArray.push(stateFull);
			}

			if (addressValue.postcode) {
				var postcode = `${addressValue.postcode}`.trim()
				var postcodeFull = postcode + ''
				addressArray.push(postcodeFull);
			}
			
			if (addressValue.country) {
				addressArray.push(addressValue.country);
			}
		}

		var gAddressValue = addressArray.join(' ');
		gAddressValue = gAddressValue.split(' ').join(' ');
		return gAddressValue
	}
}
